import { Address6 } from 'ip-address';
export const last = list => list[list.length - 1];
export const formatStringValue = value => {
  return value.replace(/\n/g, '|').replace(/\s*\|\s*/g, '|');
};
const isNumStr = value => {
  if (!/^\d+$/.test(value)) {
    return false;
  }
  return value.startsWith('0') ? value === '0' : true;
};
const isNumInRange = (range, value) => {
  if (typeof value === 'string' && !isNumStr(value)) {
    return false;
  }
  const num = Number(value);
  return num >= range[0] && num <= range[1];
};
const multipleMatch = (str, match) => {
  return str.replace(/[,;]/g, '|').split('|').every(v => match(v.trim()));
};
const isUidNum = str => {
  return /^[0-9]{16,}$/.test(str);
};
const isUid32 = str => {
  return /^[0-9a-z]{32}$/.test(str) || /^[0-9a-z]{8}(-[0-9a-z]{4}){3}-[0-9a-z]{12}$/.test(str);
};
const isUuid = str => {
  return isUidNum(str) || isUid32(str);
};
const isLikeIPv4 = str => {
  if (!str || str.includes('..') || str.includes('./')) {
    return false;
  }
  const [ip, mask, ...rest] = str.split('/');
  if (rest.length > 0) {
    return false;
  }
  if (mask && !isNumInRange([1, 32], mask)) {
    return false;
  }
  const ipNums = ip.split('.');
  if (ipNums.length > 4 || ipNums.some(n => {
    return n ? !isNumInRange([0, 255], n) : false;
  })) {
    return false;
  }
  return true;
};
const isIP = str => {
  return isLikeIPv4(str) || Address6.isValid(str);
};
const isEmail = str => {
  return /^[0-9a-zA-Z\._-]+@[0-9a-zA-Z_-]+(\.[0-9a-zA-Z_-]+)+$/.test(str);
};
export const isMatched = (match, str, multiple) => {
  switch (match) {
    case 'uuid':
      return multiple ? multipleMatch(str, isUuid) : isUuid(str);
    case 'uid-num':
      return multiple ? multipleMatch(str, isUidNum) : isUidNum(str);
    case 'uid-32':
      return multiple ? multipleMatch(str, isUid32) : isUid32(str);
    case 'email':
      return multiple ? multipleMatch(str, isEmail) : isEmail(str);
    case 'ip':
      return multiple ? multipleMatch(str, isIP) : isIP(str);
    case 'ipv4':
      return multiple ? multipleMatch(str, isLikeIPv4) : isLikeIPv4(str);
    case 'ipv6':
      return multiple ? multipleMatch(str, Address6.isValid) : Address6.isValid(str);
    default:
      if (match instanceof RegExp) {
        return multiple ? multipleMatch(str, match.test) : match.test(str);
      }
      if (typeof match === 'function') {
        return multiple ? multipleMatch(str, match) : match(str);
      }
  }
};